// extracted by mini-css-extract-plugin
module.exports = {"root":"DragDropItem_root__1NJHD","dragging":"DragDropItem_dragging__1fSQo"};